export enum ErrorType {
  DEFAULT,
  STRIPE_PT_NOT_CONNECTED,
  STRIPE_ONLINE_PAYMENT_TYPE_NOT_ENABLED,
  VERIPHONE_NOT_STARTED,
  ASK_FOR_SIMULATION_UNAUTHORIZED,
  CANT_RETRIEVE_SETTINGS
}
